export enum WebSocketTopic {
    PAYMENT_STATUS = '/user/topic/PAYMENT_STATUS',
}